import { createFileRoute } from '@tanstack/react-router'

import { WorkflowsListPage } from '#features/admin/workflows/workflows-list-page'

export const Route = createFileRoute('/_app/admin/workflows/')({
  component: WorkflowsListPage,
})
